export const SimilarProductRecommendations = "6954d507584e8af83508ac813f6427242246e9cfe993d317524b776ac842aaff";